module.exports = __webpack_public_path__ + "media/decathlon-christmas.7c25a55a.mp4";